import { useState, useCallback } from 'react'
import useStepNavigation from './useStepNavigation'
import useFileValidation from './useFileValidation'

/**
 * Composer hook for import questionnaire modal
 * Composes useStepNavigation and useFileValidation hooks
 */
const useImportSteps = collectId => {
  const [file, setFile] = useState(null)

  const {
    step,
    goToStep: navigateToStep,
    goBack,
    goNext,
    reset: resetNavigation
  } = useStepNavigation()

  const shouldValidate = step === 2
  const {
    validationResult,
    validating,
    error,
    clearValidation,
    reset: resetValidation,
    getParsedSections
  } = useFileValidation(collectId, file, shouldValidate)

  const handleFileChange = useCallback(newFile => {
    setFile(newFile)
    clearValidation()
  }, [clearValidation])

  const goToStep = useCallback(targetStep => {
    navigateToStep(targetStep)
  }, [navigateToStep])

  const reset = useCallback(() => {
    resetNavigation()
    resetValidation()
    setFile(null)
  }, [resetNavigation, resetValidation])

  return {
    step,
    file,
    validationResult,
    validating,
    error,
    setFile: handleFileChange,
    goToStep,
    goBack,
    goNext,
    getParsedSections,
    reset
  }
}

export default useImportSteps
